import { render, staticRenderFns } from "./CoursewareBiographyCareerBlock.vue?vue&type=template&id=069b2a57&scoped=true&"
import script from "./CoursewareBiographyCareerBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareBiographyCareerBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareBiographyCareerBlock.vue?vue&type=style&index=0&id=069b2a57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b2a57",
  null
  
)

export default component.exports